import { useTranslation } from "react-i18next";

export function Footer() {
  const { i18n } = useTranslation();

  const feedbackText = i18n.language === "ja"
    ? "フィードバック"
    : i18n.language === "ko"
    ? "피드백"
    : i18n.language === "de"
    ? "Feedback"
    : i18n.language === "ru"
    ? "Обратная связь"
    : i18n.language === "ar"
    ? "تعليق"
    : "Feedback";

  const aboutText = i18n.language === "ja"
    ? "について"
    : i18n.language === "ko"
    ? "정보"
    : i18n.language === "de"
    ? "Über"
    : i18n.language === "ru"
    ? "О нас"
    : i18n.language === "ar"
    ? "حول"
    : "About";

  return (
    <footer className="mt-12 py-8 bg-white/50 backdrop-blur-sm">
      <div className="container mx-auto px-4">
        <div
          className={`flex flex-col md:flex-row justify-between items-center gap-4 ${
            i18n.language === "ar" ? "flex-row-reverse" : ""
          }`}
        >
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
              <span className="text-white text-sm font-bold">T</span>
            </div>
            <span className="font-semibold text-gray-800">Text Tools</span>
          </div>
          <div className="text-sm text-gray-600">© 2026 Text Tools. All rights reserved.</div>
          <div
            className={`flex gap-4 text-sm text-gray-500 ${
              i18n.language === "ar" ? "flex-row-reverse" : ""
            }`}
          >
            <a href="#" className="hover:text-blue-600 transition-colors">GitHub</a>
            <a href="#" className="hover:text-blue-600 transition-colors">{feedbackText}</a>
            <a href="#" className="hover:text-blue-600 transition-colors">{aboutText}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
